import React from 'react';
import styled from 'styled-components';

import {
  Rows,
  Section,
  SectionTitle,
  Row,
  RowLabel,
} from 'modules/health/commonStyles/header';
import { formatNumber } from 'modules/health/helpers/formatNumber';

interface AvgPointsProps {
  thisMonth: number;
  thisQuarter: number;
  thisYear: number;
}

const AvgPoints = ({ thisMonth, thisQuarter, thisYear }: AvgPointsProps) => {
  const pointsRows = [
    { label: 'This month', value: thisMonth },
    { label: 'This quarter', value: thisQuarter },
    { label: 'This year', value: thisYear },
  ];

  return (
    <Section>
      <SectionTitle>Avg points earned</SectionTitle>
      <Rows>
        {pointsRows.map((row) => (
          <Row key={row.label}>
            <RowLabel>{row.label}</RowLabel>
            <AvgValue>{formatNumber(row.value)}</AvgValue>
          </Row>
        ))}
      </Rows>
    </Section>
  );
};

const AvgValue = styled.div`
  font-weight: 700;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.white};
`;

export default AvgPoints;
